import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_671ab018 from 'nuxt_plugin_sentryserver_671ab018' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_01613e90 from 'nuxt_plugin_sentryclient_01613e90' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_workbox_22b93470 from 'nuxt_plugin_workbox_22b93470' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_bootstrapvue_c77c62fa from 'nuxt_plugin_bootstrapvue_c77c62fa' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_plugin_6c08a1ce from 'nuxt_plugin_plugin_6c08a1ce' // Source: ./composition-api/plugin.js (mode: 'all')
import nuxt_plugin_templatesplugin4a460e16_a916650a from 'nuxt_plugin_templatesplugin4a460e16_a916650a' // Source: ./templates.plugin.4a460e16.js (mode: 'client')
import nuxt_plugin_clipboard_2beb1db4 from 'nuxt_plugin_clipboard_2beb1db4' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_pluginrouting_94e0a81c from 'nuxt_plugin_pluginrouting_94e0a81c' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2c3fd686 from 'nuxt_plugin_pluginmain_2c3fd686' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_apollomodule_de2887c0 from 'nuxt_plugin_apollomodule_de2887c0' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_060ef758 from 'nuxt_plugin_axios_060ef758' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuecurrencyinput_65869822 from 'nuxt_plugin_vuecurrencyinput_65869822' // Source: ./vue-currency-input.js (mode: 'all')
import nuxt_plugin_fontawesome_6146c896 from 'nuxt_plugin_fontawesome_6146c896' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_googlegtag_bd36b7fa from 'nuxt_plugin_googlegtag_bd36b7fa' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_gtm_5f935fac from 'nuxt_plugin_gtm_5f935fac' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_chart_48b5b405 from 'nuxt_plugin_chart_48b5b405' // Source: ../src/plugins/chart.ts (mode: 'all')
import nuxt_plugin_vuelidate_4be42f5c from 'nuxt_plugin_vuelidate_4be42f5c' // Source: ../src/plugins/vuelidate.ts (mode: 'all')
import nuxt_plugin_veeValidate_704b8452 from 'nuxt_plugin_veeValidate_704b8452' // Source: ../src/plugins/veeValidate.ts (mode: 'all')
import nuxt_plugin_themask_b54be9b4 from 'nuxt_plugin_themask_b54be9b4' // Source: ../src/plugins/themask.ts (mode: 'all')
import nuxt_plugin_numeral_26f7c30f from 'nuxt_plugin_numeral_26f7c30f' // Source: ../src/plugins/numeral.js (mode: 'all')
import nuxt_plugin_loadingScreen_fff3364a from 'nuxt_plugin_loadingScreen_fff3364a' // Source: ../src/plugins/loadingScreen.ts (mode: 'all')
import nuxt_plugin_apolloprovide_ac85e818 from 'nuxt_plugin_apolloprovide_ac85e818' // Source: ../src/plugins/apollo-provide.ts (mode: 'all')
import nuxt_plugin_hotjar_6900f5d3 from 'nuxt_plugin_hotjar_6900f5d3' // Source: ../src/plugins/hotjar.js (mode: 'client')
import nuxt_plugin_ganalytics_a4c70a3c from 'nuxt_plugin_ganalytics_a4c70a3c' // Source: ../src/plugins/ganalytics.js (mode: 'client')
import nuxt_plugin_pdfjs_78b9d05c from 'nuxt_plugin_pdfjs_78b9d05c' // Source: ../src/plugins/pdfjs.js (mode: 'client')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../src/plugins/swiper.js (mode: 'client')
import nuxt_plugin_aos_78651e70 from 'nuxt_plugin_aos_78651e70' // Source: ../src/plugins/aos.js (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../src/plugins/axios (mode: 'all')
import nuxt_plugin_plugin_31580290 from 'nuxt_plugin_plugin_31580290' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../src/plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Balko","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Otimize seu portfolio investindo em ativos alternativos com quem entende do assunto. Rentabilidade-alvo de 15% a 25% a.a. com ativos aprovados em rigorosas diligências."},{"property":"og:url","content":"https:\u002F\u002Fwww.balko.com.br"},{"property":"og:type","content":"article"},{"property":"og:title","content":"Balko"},{"property":"og:description","content":"Otimize seu portfolio investindo em ativos alternativos com quem entende do assunto. Rentabilidade-alvo de 15% a 25% a.a. com ativos aprovados em rigorosas diligências."},{"property":"og:image","content":"\u002Fstatic\u002Ficons\u002Ficon-512x512.png"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Balko"},{"hid":"author","name":"author","content":"Balko"},{"hid":"theme-color","name":"theme-color","content":"#fff"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"Balko"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fstatic\u002Ficons\u002Ffavicon.ico"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.b22f1b63.json"}],"script":[{"src":"https:\u002F\u002Fpolyfill.io\u002Fv3\u002Fpolyfill.min.js?features=IntersectionObserver%2CIntersectionObserverEntry","body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KM2KDBN')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=UA-137461486-2","async":true}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KM2KDBN&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_671ab018 === 'function') {
    await nuxt_plugin_sentryserver_671ab018(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_01613e90 === 'function') {
    await nuxt_plugin_sentryclient_01613e90(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_22b93470 === 'function') {
    await nuxt_plugin_workbox_22b93470(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_c77c62fa === 'function') {
    await nuxt_plugin_bootstrapvue_c77c62fa(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_6c08a1ce === 'function') {
    await nuxt_plugin_plugin_6c08a1ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin4a460e16_a916650a === 'function') {
    await nuxt_plugin_templatesplugin4a460e16_a916650a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_2beb1db4 === 'function') {
    await nuxt_plugin_clipboard_2beb1db4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_94e0a81c === 'function') {
    await nuxt_plugin_pluginrouting_94e0a81c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2c3fd686 === 'function') {
    await nuxt_plugin_pluginmain_2c3fd686(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_de2887c0 === 'function') {
    await nuxt_plugin_apollomodule_de2887c0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_060ef758 === 'function') {
    await nuxt_plugin_axios_060ef758(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecurrencyinput_65869822 === 'function') {
    await nuxt_plugin_vuecurrencyinput_65869822(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_6146c896 === 'function') {
    await nuxt_plugin_fontawesome_6146c896(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_bd36b7fa === 'function') {
    await nuxt_plugin_googlegtag_bd36b7fa(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_5f935fac === 'function') {
    await nuxt_plugin_gtm_5f935fac(app.context, inject)
  }

  if (typeof nuxt_plugin_chart_48b5b405 === 'function') {
    await nuxt_plugin_chart_48b5b405(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be42f5c === 'function') {
    await nuxt_plugin_vuelidate_4be42f5c(app.context, inject)
  }

  if (typeof nuxt_plugin_veeValidate_704b8452 === 'function') {
    await nuxt_plugin_veeValidate_704b8452(app.context, inject)
  }

  if (typeof nuxt_plugin_themask_b54be9b4 === 'function') {
    await nuxt_plugin_themask_b54be9b4(app.context, inject)
  }

  if (typeof nuxt_plugin_numeral_26f7c30f === 'function') {
    await nuxt_plugin_numeral_26f7c30f(app.context, inject)
  }

  if (typeof nuxt_plugin_loadingScreen_fff3364a === 'function') {
    await nuxt_plugin_loadingScreen_fff3364a(app.context, inject)
  }

  if (typeof nuxt_plugin_apolloprovide_ac85e818 === 'function') {
    await nuxt_plugin_apolloprovide_ac85e818(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_6900f5d3 === 'function') {
    await nuxt_plugin_hotjar_6900f5d3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ganalytics_a4c70a3c === 'function') {
    await nuxt_plugin_ganalytics_a4c70a3c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pdfjs_78b9d05c === 'function') {
    await nuxt_plugin_pdfjs_78b9d05c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_78651e70 === 'function') {
    await nuxt_plugin_aos_78651e70(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_31580290 === 'function') {
    await nuxt_plugin_plugin_31580290(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
